import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import Contact from "./pages/Contact";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/projekter" element={<Projects />} />
                        <Route
                            path="/projekter/:slug"
                            element={<ProjectDetail />}
                        />
                        <Route path="/om-os" element={<About />} />
                        <Route path="/kontakt" element={<Contact />} />
                        <Route path="*" element={<Home />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </div>
    );
}

export default App;
